var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrumsStemTop = function SvgDrumsStemTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.438,
    d: "M10.328 10.357.75 21.593m15.622-13.35L13.58 22.741M22 10.5a9.5 9.5 0 1 1-19 0 9.5 9.5 0 0 1 19 0Zm-11.14-.767a.82.82 0 1 1-1.064 1.248.82.82 0 0 1 1.064-1.248Zm5.668-2.295a.82.82 0 1 1-.31 1.61.82.82 0 0 1 .31-1.61Z"
  })));
};
export default SvgDrumsStemTop;